module.exports = __webpack_public_path__ + "img/georgia.dc83ff8f.svg";